import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getPureCourse = courseId => httpClient.get(`${apis.GET_PURE_COURSE}/${courseId}`);
